<template>
    <el-container class="approval-record-list">
        <el-main>
            <!-- <div class="tools-bar">
                <div class="tools-search">
                    <el-form :inline="true" class="demo-form-inline">
                        <el-form-item label="审批人">
                            <el-input readonly style="width: 100px;" v-model="selectedProcessUser.selectedUserNames" @focus="chooseProcessAssigneeUser" ></el-input>
                            <UserOrgPop :key="loadTimer" :isShowUserOrg='isShowProcessUserOrg'  :selectedUser="selectedProcessUser" ref="processUserOrgPop" @nodeClick="processAssigneeSelectTrigger" />
                        </el-form-item>
                        <el-button type="primary" icon="el-icon-search" circle @click="handleSearch"></el-button>
                    </el-form>
                </div>
            </div> -->
            <el-table 
                :data="updRecordList"  
                row-key="id" 
                style="width: 95%" 
                :border="true" 
                v-loading="loading">
                <el-table-column
                    type="index"
                    width="50">
                </el-table-column>
                <el-table-column
                    label="修改人"
                    prop="createdTrueName"
                    :show-overflow-tooltip="true"
                    align="center"
                    width="180">
                </el-table-column>
                <el-table-column
                    label="修改时间"
                    align="center"
                    sortable
                    prop="created"
                    width="200">
                </el-table-column>
                <el-table-column
                    label="修改内容"
                    align="center"
                    prop="updContent">
                </el-table-column>
            </el-table>
            <el-row type="flex" justify="end">
                <el-pagination
                    background
                    layout="total,sizes, prev, pager, next"
                    :total="page.totalPageNum"
                    :current-page="page.currentPage"
                    :page-size="page.pageSize"
                    :page-sizes="[10, 20, 30, 50, 100]"
                    @current-change="queryFormData"
                    @size-change="queryFormDataByPageSize"
                />
            </el-row>
        </el-main>
    </el-container>
</template>

<script>
    import {getFormDataUpdRecordBOList} from '@/data-model';
    import ApprovalFiles from '@/components/ApprovalFiles';
    import mixinsNav from '@/mixins/mixins-nav';

    export default {
        components: {
            ApprovalFiles
        },
        mixins: [ mixinsNav ],
        data () {
            return {
                currentApprovalInstanceId: '',
                loadTimer: '',
                isShowApprovalFileDialog: false,
                page: {
                    currentPage: 1, // 当前页码
                    pageSize: 10, // 每页条数
                    totalPageNum: 1 // 总页数
                },
                searchParams: {
                    modelInstanceId: ''
                },
                loading: false,
                updRecordList: []
            };
        },
        props: {
            modelInstanceId: {
                type: String
            }
        },
        computed: {
        },
        created () {
            this.loadTimer = new Date().getTime();
            this._initPage();
        },
        methods: {
            async _initPage () {
                this._getFormData();
            },
            async _getFormData () {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.searchParams.modelInstanceId = this.modelInstanceId;
                let formData = await getFormDataUpdRecordBOList(Object.assign({}, {
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize
                }, this.searchParams));
                if (formData && formData.data) {
                    this.updRecordList = formData.data;
                } else {
                    this.updRecordList = [];
                }
                this.page.totalPageNum = formData.totalPageNum;
                loading.close();
            },
            queryFormData (currentPage) {
                this.page.currentPage = currentPage;
                this._getFormData();
            },
            queryFormDataByPageSize (pageSize) {
                this.page.pageSize = pageSize;
                this._getFormData();
            },
            handleSearch () {
                this.page.currentPage = 1;
                this._getFormData();
            }
        }
    };
</script>

<style lang="less">
    .approval-record-list {
        .el-header {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .el-main {
            padding: 0;
        }

        .el-aside {
            border-right: 1px solid #dcdfe6;
        }
    }
    .span-line{
      color:rgb(19, 206, 102);
    }
    .span-line:hover{
        text-decoration:underline;
    }
    .span-line-right{
        margin-right: 2px;
        float: right;
    }
</style>



// WEBPACK FOOTER //
// src/components/FormDataUpdRecordList/FormDataUpdRecordList.vue